<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <ThirdProductClassify/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import ThirdProductClassify from "@/views/business/product/thirdProductClassify.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ThirdProductClassify,
    Footer
  },
}
</script>

<style>
</style>